
      import { version } from './package.json';

      document.head.insertAdjacentHTML(
        'beforeend',
        `<meta name='version' content=${version}>`
      );
    